import { useQuery } from 'react-query'

import { getConfigDictionary } from '../api/config/getConfigDictionary'

export const useConfigDictionaryQuery = () => useQuery(['config-dictionary'], getConfigDictionary)
